import { ReactNode } from 'react';
import { splitStylesProp, type StylesProp } from '../../helpers/styles-prop';
import { PopoverMenu, type PopoverMenuProps } from '../popover/menu/popover-menu.component';

export const ComboboxBase = <T extends HTMLElement = HTMLElement>({
  Input,
  menuProps,
  children,
  menuStyles,
}: {
  Input: ReactNode;
  menuProps: Omit<PopoverMenuProps<T>, 'initialFocus' | 'children'>;
  children: ReactNode;
  menuStyles?: StylesProp;
}) => {
  const { css: splitCss, className: splitClassName } = splitStylesProp(menuStyles);

  return (
    <>
      {Input}
      <PopoverMenu css={splitCss} className={splitClassName} {...menuProps} initialFocus={-1}>
        {children}
      </PopoverMenu>
    </>
  );
};
